import React from "react";
import FormControl from "@mui/material/FormControl";
import InputAdornment from "@mui/material/InputAdornment";
import "./Stylesheet.css";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormHelperText from "@mui/material/FormHelperText";
const InputFieldPassword = ({
  autoFocus,
  icon,
  type,
  label,
  value,
  onChngeterm,
  error,
  helperText,
  disabled,
}) => {
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  return (
    <>
      <FormControl variant="standard" fullWidth>
        <OutlinedInput
          style={{ borderRadius: "100px", height: "45px", width: "100%" }}
          placeholder={label}
          autoFocus={autoFocus}
          value={value}
          type={showPassword ? "text" : "password"}
          disabled={disabled}
          onChange={onChngeterm}
          startAdornment={<InputAdornment position="start">{icon}</InputAdornment>}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
          error={error}
        />
        <FormHelperText style={{ color: "red" }}>{helperText}</FormHelperText>
      </FormControl>
    </>
  );
};

export default InputFieldPassword;
